import { useCallback } from 'react';
import { useLocation } from 'react-router-dom';
import { driver } from 'driver.js';
import 'driver.js/dist/driver.css';
import tourConfigs from './tourConfigs';

/**
 * Custom hook to get and start Driver.js tour for the current page
 */
export const useTour = () => {
  const location = useLocation();

  const getTourConfig = useCallback(() => {
    // Try exact match first
    let config = tourConfigs[location.pathname];

    // If no exact match, try partial match (for dynamic routes like /help-desk/user-chat/:id)
    if (!config) {
      const pathParts = location.pathname.split('/');
      for (const key of Object.keys(tourConfigs)) {
        const keyParts = key.split('/');
        if (keyParts.length === pathParts.length) {
          const match = keyParts.every((kp, i) => kp.startsWith(':') || kp === pathParts[i]);
          if (match) { config = tourConfigs[key]; break; }
        }
      }
    }

    return config || null;
  }, [location.pathname]);

  const startTour = useCallback(() => {
    const config = getTourConfig();
    if (!config || !config.steps || config.steps.length === 0) return;

    const driverObj = driver({
      showProgress: true,
      showButtons: ['next', 'previous', 'close'],
      steps: config.steps.map(step => ({
        ...step,
        popover: {
          ...step.popover,
          side: step.popover?.side || 'bottom',
          align: step.popover?.align || 'start',
        }
      })),
      popoverClass: 'cc-tour-popover',
      stagePadding: 8,
      stageRadius: 8,
      animate: true,
      overlayColor: 'rgba(0, 0, 0, 0.6)',
      nextBtnText: 'Next →',
      prevBtnText: '← Back',
      doneBtnText: 'Got it!',
    });

    driverObj.drive();
  }, [getTourConfig]);

  return { startTour, tourConfig: getTourConfig() };
};

export default useTour;
